import { HpClientQuestion, HpClientQuestionUI } from '../../../types';

export function isDisabled(question: HpClientQuestion, ui: HpClientQuestionUI): boolean {
  const { disabled } = question;
  let { disabled: isDisabled = false } = ui;
  if (disabled) {
    isDisabled = disabled;
  }

  return isDisabled;
}
